<div class="daypart-container">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div *ngIf="hasData">
		<h2 class="daypart-title">Time of Day {{ timezone }}</h2>
		<app-generic-chart
			[colorPalette]="colorPalette"
			[configuration]="widgetsConfiguration"
			[data]="dayPartData"
		></app-generic-chart>
	</div>
	<div *ngIf="!hasData">
		<h2 class="daypart-title">Time of Day</h2>
		<div class="daypart-no-data">
			<div class="no-data-text"><h3>No Data Available</h3></div>
		</div>
	</div>
</div>
